var React = require('react');

function UiArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M300.675 0.00013819L573.732 275.8C602.613 299.44 602.613 341.467 578.983 370.36C555.353 399.253 513.344 399.253 484.463 375.613C481.838 372.987 481.838 372.987 479.212 370.36L298.049 191.747L116.886 372.987C93.2564 401.88 51.2476 401.88 22.3666 378.24C-6.51448 354.6 -6.5145 312.573 17.1155 283.68C19.741 281.053 19.741 281.053 22.3666 278.427L300.675 0.00013819Z"}));
}

UiArrowUp.defaultProps = {"viewBox":"0 0 597 396","fill":"none"};

module.exports = UiArrowUp;

UiArrowUp.default = UiArrowUp;
